import React, { memo, useRef } from "react";
import cn from "classnames";

import { ButtonColorScheme, ButtonType } from "types/ui";

type Props = React.PropsWithChildren<{
  title?: string | React.ReactNode;
  onClick: () => void;
  type?: ButtonType;
  colorScheme?: ButtonColorScheme;
  classNames?: string;
  shadowed?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  id?: string;
  iconPath?: string;
  setRef?: (ref: HTMLButtonElement | null) => void;
}>;
export const Button = memo(
  ({
    title,
    onClick,
    type = ButtonType.normal,
    colorScheme,
    classNames,
    shadowed,
    disabled,
    style,
    id,
    iconPath,
    setRef,
    children,
  }: Props) => {
    const refButton = useRef<HTMLButtonElement>(null);
    return (
      <button
        id={id}
        aria-describedby={id}
        type="button"
        ref={refButton}
        disabled={disabled}
        style={style}
        className={cn(`rounded-lg font-bold ${classNames}`, {
          "px-4 py-2 text-base": type === ButtonType.normal,
          "px-3 py-1 text-[11px]": type === ButtonType.small,
          "px-5 py-[11px] text-lg min-w-[143px] rounded-[10px]":
            type === ButtonType.large,
          "px-4 py-2 text-base bg-transparent": type === ButtonType.text,
          "px-3 pb-1 text-sm border-2 border-black font-bold bg-none":
            type === ButtonType.outline,
          "text-white bg-primary": colorScheme === ButtonColorScheme.primary,
          "text-white bg-accent": colorScheme === ButtonColorScheme.accent,
          "text-white bg-[#161728]": colorScheme === ButtonColorScheme.dark,
          "text-bgDark bg-border": colorScheme === ButtonColorScheme.default,
          "text-white btn-gradient": colorScheme === ButtonColorScheme.gradient,
          "text-danger": colorScheme === ButtonColorScheme.danger,
          "text-grayDark bg-border": colorScheme === ButtonColorScheme.disabled,
          "btn-shadow": shadowed,
        })}
        onClick={() => {
          if (setRef) setRef(refButton.current);
          onClick();
        }}
      >
        {iconPath && (
          <img src={iconPath} style={{ display: "inline", marginRight: 5 }} />
        )}
        <p style={{ display: "inline" }}>{title ?? children}</p>
      </button>
    );
  }
);
